import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { UserRole } from '@shared/index';

// ─────────────────────────────────────────────────────────────────────────────
// AdminRoute
//
// Wrap routes that require an elevated role (EDITOR or ADMIN).
// - Not authenticated → /login?redirect=…
// - Authenticated but wrong role → / (home)
// ─────────────────────────────────────────────────────────────────────────────

const ALLOWED_ROLES: UserRole[] = ['ADMIN', 'EDITOR'];

export default function AdminRoute() {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location                             = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-terminal-bg">
        <span className="animate-pulse font-mono text-terminal-green">
          Authenticating…
        </span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!user || !ALLOWED_ROLES.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
